import { Button, Divider, ShareIcon, Wrapper, Image, P } from '@farewill/ui'
import { COLOR, FONT, GTR } from '@farewill/ui/tokens'
import React from 'react'
import styled from 'styled-components'

const StyledDiv = styled('div')`
  display: flex;
  padding: ${GTR.M} ${GTR.M} ${GTR.L} ${GTR.M};
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;

  border-radius: 16px;
  background: ${COLOR.ACCENT.PRIMARY_10};

  margin-bottom: ${GTR.L};
`

const StyledP = styled(P)`
  font-size: ${FONT.SIZE.M};
  margin-bottom: 0;
`

const BoldStyledP = styled(P)`
  font-weight: ${FONT.WEIGHT.BOLD};
  line-height: 1.33;
  margin-bottom 0;
  color: ${COLOR.BLACK};
`

const StyledH3 = styled('h3')`
  font-size: ${FONT.SIZE.L};
  font-weight: ${FONT.WEIGHT.BOLD};
  line-height: 1.25;
  color: ${COLOR.BLACK};
  margin-bottom: 0;
`

const Box = ({ roleUrl }: { roleUrl: string }): React.JSX.Element => (
  <Wrapper margin={[GTR.L, 0, 0, 0]}>
    <StyledDiv>
      <Image
        path="e_trim/illustrations/cropped/blob-with-family"
        width={190}
        stretch
      />
      <StyledH3>We’re building a diverse, inclusive team</StyledH3>
      <StyledP>
        To change the way the world deals with death we need a team that
        celebrates diversity in all its forms. We’re building a workplace where
        everyone is treated fairly and respectfully.
      </StyledP>
      <StyledP>
        If you’re excited about our mission but you’re worried you don’t tick
        every box in the job description, get in touch anyway. Ability and
        attitude are just as important as experience.
      </StyledP>
      <BoldStyledP>Let us know how we can support you</BoldStyledP>
      <StyledP>
        If you need any adjustments in our interview process to help set you up
        for success, just let us know.
      </StyledP>
      <Divider margin={['12px', 0]} />
      <StyledH3>What are the next steps</StyledH3>
      <StyledP>
        Apply via the Dignity website by clicking the link on this page. A
        member of Dignity’s Talent Team will review your application and be in
        touch.
      </StyledP>
    </StyledDiv>
    <Button.Primary
      stretch
      href={roleUrl}
      target="_blank"
      rel="noopener noreferrer"
    >
      <ShareIcon width={24} />
      &nbsp;Apply via Dignity
    </Button.Primary>
  </Wrapper>
)

export default Box
